import {Component, OnInit} from '@angular/core';
import {RouterOutlet, Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet],
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{
  title = 'screening-webapp';

  constructor(private router: Router) { }

  ngOnInit() { }
}
